import React from 'react';
import clsx from 'clsx';
import useStyles from './FileIcons.styles';

export type IFileType = 'alertIcon' | 'uploadIcon' | 'deleteIcon';

interface IFileIconProps {
  iconType: IFileType;
}

export const FileIcon: React.FC<IFileIconProps> = ({ iconType }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <i
        className={clsx(classes[iconType], classes.icon)}
        data-qa-name="file_icon"
      />
    </div>
  );
};
